import { RpcService } from '@holmescorp/rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        get_state: {
            parameters: [
                {
                    name: 'key',
                    type: 'string',
                    optional: false
                }
            ]
        },
        pretest_quizzes: {
            parameters: [
                {
                    name: 'site',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'menu',
                    type: 'string',
                    optional: true
                }
            ]
        },
        quiz_state: {
            parameters: [
                {
                    name: 'site',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'quizids',
                    type: 'array',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
